import { Action, TemplateDeploymentState, TemplateDeploymentType } from "types/generated";
import { AccessResult, EntityWithAllowedActions, NO_ACCESS_MESSAGE } from "utils/access";

import { isDeploymentUpdateDisabled, getUpdateDisabledTooltip } from "./helpers";

type DeploymentWithState = EntityWithAllowedActions & {
  state: TemplateDeploymentState;
  deploymentType: TemplateDeploymentType;
};

export const canUpdateTemplateDeployment = (deployment: DeploymentWithState): AccessResult => {
  if (!deployment.allowedActions.includes(Action.UpgradeBlueprintDeployment)) {
    return { result: false, message: NO_ACCESS_MESSAGE };
  }

  if (deployment.deploymentType === TemplateDeploymentType.Test) {
    return { result: false, message: "Test deployments cannot be updated" };
  }

  if (isDeploymentUpdateDisabled(deployment.state)) {
    return { result: false, message: getUpdateDisabledTooltip(deployment.state) };
  }

  return { result: true };
};
